// extracted by mini-css-extract-plugin
export default {"icon":"MyPurchasesTab_icon__jaaJX","link":"MyPurchasesTab_link__1uOjr"};